<template>
  <div class="Video">
    <video playsinline ref="video" :src="videoPath" @playing="onPlaying" @ended="onEnded" :autoplay="false" />
  </div>
</template>

<script>

import { TweenLite } from 'gsap'

export default {
  name: 'Video',
  props: {
    onHit: Function,
    onMiss: Function,
    onStart: Function,
    onGameComplete: Function,
    // game: String,
    keyframes: Array,
    toggleGameActiveState: Function,
    gameLength: Number
  },
  data() {
    return {
      frameRate: 30,
      currentFrame: 0,
      timeout: null,
      interval: null,
      last: 0,
      isTargetVisible: false,
      hasHit: false,
      isVideoPlaying: false,
      trigger: 0,
      targetFrames: [...this.keyframes],
      isTriggerActive: true,
      gameState: 0,
    }
  },
  watch: {
    trigger: function( newVal, oldVal) {

      // console.log('Prop changed Trigger: ', newVal, ' | was: ', oldVal)

      if ( newVal > 0 && this.isTriggerActive  ) { // If new val is a trigger

        this.isTriggerActive = false
        this.onTrigger()

        setTimeout( () => {
          this.isTriggerActive = true
        }, 250 )
      }
    }
  },
  beforeDestroy() {
     this.pauseVideo()
     clearInterval( this.interval )
     this.isVideoPlaying = false
  },
  mounted() {
    TweenLite.to( this.$refs.video, 0, { opacity: '0' } )

    this.activeFrames = this.targetFrames.filter( ( element, index ) => {
      return index % 2 != 0;
    } )

    this.inactiveFrames = this.targetFrames.filter( ( element, index ) => {
      return index % 2 == 0;
    } )
  },
  computed: {
    videoPath() { return require(`@/assets/videos/game_${ this.$store.state.game }_0${ Math.floor( Math.random() * 3 ) + 1 }.mp4`) }
  },
  methods: {
    playVideo() {
      TweenLite.to( this.$refs.video, 0.3, { opacity: '1' } )

      // this.$refs.video.play()

      var playPromise = this.$refs.video.play()

        // In browsers that don’t yet support this functionality,
        // playPromise won’t be defined.
        if (playPromise !== undefined) {
          playPromise.then(() => {
            // Automatic playback started!
            this.isVideoPlaying = true

            this.interval = setInterval( () =>  {
             this.getCurrentFrame()
           }, ( 1000 / this.frameRate ) )
       }).catch((error) => {
              console.log(error)
            // Automatic playback failed.
            // Show a UI element to let the user manually start playback.
          });
        }


      document.body.onkeydown = ( e ) => {

        if ( e.keyCode == 32 ) this.onTrigger()

      }
    },
    pauseVideo() {
      this.$refs.video.pause()
    },
    onPlaying() {
     //  this.isVideoPlaying = true
     //
     //  this.interval = setInterval( () =>  {
     //   this.getCurrentFrame()
     // }, ( 1000 / this.frameRate ) )
    },
    onEnded() {
      if ( !this.isVideoPlaying ) return

      document.body.onkeydown = null

      this.trigger = 0
      this.isVideoPlaying = false

      TweenLite.to( this.$refs.video, 0.3, { opacity: '0' }, 1 )

      clearInterval(this.interval)

      this.onGameComplete()
    },
    onTrigger() {
      if ( !this.isVideoPlaying ) return;

      if ( this.isTargetVisible && !this.hasHit ) {
        this.hasHit = true;
        this.onHit();
      } else if ( !this.isTargetVisible ) {
        this.onMiss();
      }
    },
    getCurrentFrame() {
      if ( !this.$refs.video ) return

      let curTime = this.$refs.video.currentTime

      this.currentFrame = Math.floor( curTime * this.frameRate )

      if ( this.activeFrames.includes( this.currentFrame ) ) {

        this.hasHit = false
        this.isTargetVisible = true

      } else if ( this.inactiveFrames.includes( this.currentFrame ) ) {

        this.hasHit = false
        this.isTargetVisible = false

      }

      if ( this.currentFrame > 80 && this.gameState < 1 ) {
          this.gameState = 1
          this.toggleGameActiveState()
      }

      if ( ( this.currentFrame == ( this.gameLength + 3 ) * 30 ) && this.gameState > 0 ) {
          this.gameState = 0
          this.toggleGameActiveState()
      }

      // if ( this.currentFrame == 80 ) this.toggleGameActiveState()
      // if ( this.currentFrame == ( this.gameLength + 3 ) * 30 ) this.toggleGameActiveState()
    }
  }
}
</script>

<style scoped lang="scss">

@import '@/styles/core.scss';

  .Video {

    video {

      object-fit: contain;
      max-width: rem( 800 );
      width: 100%;

      max-height: 55vh;

      @include breakpoint( tablet ) {

        width: 60%;

      }

      @include breakpoint( mobile-all ) {

        margin-top: -15%;
        width: 80%;

      }

      @include breakpoint-width( 375px, 667px ) {

        width: 70%;
        margin-top: 5%;

      }

    }

  }

</style>
